<template>
<div
    v-if="profile != null"
>

   <v-row>
        <v-col>
            <m-edit-text
                label="Bandwidth Campaign Id"
                :value="profile.campaign_registry_settings.default_tcr_campaign_id_bandwidth"
                :menu_items="[{'text' : 'Set...', 'event' : 'set'}, {'text' : 'Clear...', 'event' : 'clear'}]"
                v-on:set="onClickSetCampaignId('bandwidth')"
                v-on:clear="onClickClearCampaignId('bandwidth')"
                optional
            />
        </v-col>

        <v-col>
            <m-edit-text
                label="Twilio Campaign Id"
                :value="profile.campaign_registry_settings.default_tcr_campaign_id_twilio"
                :menu_items="[{'text' : 'Set...', 'event' : 'set'}, {'text' : 'Clear...', 'event' : 'clear'}]"
                v-on:set="onClickSetCampaignId('twilio')"
                v-on:clear="onClickClearCampaignId('twilio')"
                optional
            />
        </v-col>
    </v-row>

    <v-select
        label="Register new phone numbers with"
        v-model="profile.organization_account.register_new_phone_numbers_with"
        :items="$rc.enumChoices('comm_network',false)"
        v-on:change="patchOrganization"
    />

    <m-edit-text
        label="Override HELP Response (optional)"
        :value="profile.campaign_registry_settings.override_help_message"
        v-on:input="setCampaignRegistryCustomHelpMessage($event)"
        :hint="'Default: '+profile.default_ctia_help_message"
        optional
    /> 

    <p>
        <v-switch
            label="This section is complete"
            v-model="profile.provision_info.complete_tcr"
            v-on:change="onChangeCompleteSwitch"
        />
    </p>

    <m-dialog-select-tcr-campaign
        ref="dialog-select-tcr-campaign"
        :org_label="profile.organization_account.label"
        v-on:input="onSetCampaignId"
    />

</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {
         profile: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
        onChangeCompleteSwitch() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/provision/provision-info',
            
                'params' : this.profile.provision_info,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to mark the rate card section as complete',
            });
        },

        onClickSetCampaignId(comm_network)
        {
            this.$refs['dialog-select-tcr-campaign'].showDialog(comm_network);
        },

        onSetCampaignId(settings)
        {
            let new_tcr_settings = _.cloneDeep(this.profile.campaign_registry_settings);


            if ( settings.comm_network == 'bandwidth' )
            {
                new_tcr_settings.default_tcr_brand_id_bandwidth = settings.brand_id;
                new_tcr_settings.default_tcr_campaign_id_bandwidth = settings.campaign_id;
            }

            if ( settings.comm_network == 'twilio' )
            {
                new_tcr_settings.default_tcr_brand_id_twilio = settings.brand_id;
                new_tcr_settings.default_tcr_campaign_id_twilio = settings.campaign_id;
            }

            this.putTCRSettings(new_tcr_settings);
        },

        onClickClearCampaignId(comm_network)
        {
            this.$rc.confirm({
                'title': 'Confirm Clear Campaign Id',
                'body': 'Are you sure that you would like to clear the '+comm_network+' campaign id for this organization?',
                'btn_text_ok': 'Clear Campgin Id',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.onSetCampaignId(
                        {
                            'comm_network': comm_network,
                            'brand_id': null,
                            'campaign_id': null,
                        }
                    );
                },
            });
        },

        setCampaignRegistryCustomHelpMessage(message)
        {
            let new_tcr_settings = _.cloneDeep(this.profile.campaign_registry_settings);
            new_tcr_settings.override_help_message = message;
            
            this.putTCRSettings(new_tcr_settings);
        },

        putTCRSettings(new_tcr_settings)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/organizations/campaign-registry-settings',
            
                'params' : new_tcr_settings,
            
                'on_success': (data) => {
                        this.$emit('reload');
                    },
            
                'on_error': 'Unable to save TCR settings',
            });
        },


        patchOrganization()
        {
            let organization_account = this.profile.organization_account;

            let patch = {
                'organization_id': organization_account.organization_id,
                'register_new_phone_numbers_with' : organization_account.register_new_phone_numbers_with,
            };

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/organizations/organization-account',
            
                'params' : patch,
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to save changes to organization',
            });
        },
    },
}
</script>

<style lang="scss" scoped>

</style>